import React from 'react';
import { Alert, AlertTitle, IconButton, Box, Button } from '@mui/material';
import { Close as CloseIcon, Warning as WarningIcon } from '@mui/icons-material';
import { useLicense } from '../contexts/LicenseContext';
import { useNavigate } from 'react-router-dom';

const LicenseWarningBanner = () => {
  const {
    showLicenseWarning,
    dismissLicenseWarning,
    warningMessage,
    isInGracePeriod,
    daysInGrace,
    daysRemaining
  } = useLicense();

  const navigate = useNavigate();

  if (!showLicenseWarning) {
    return null;
  }

  const getMessage = () => {
    if (warningMessage) {
      return warningMessage;
    }
    if (isInGracePeriod && daysInGrace !== null) {
      return `Your license has expired! You have ${daysInGrace} days remaining in the grace period. Please renew your license to avoid service interruption.`;
    }
    if (daysRemaining !== null && daysRemaining <= 30) {
      return `Your license will expire in ${daysRemaining} days. Please renew soon to avoid service interruption.`;
    }
    return 'Your license requires attention. Please check the license settings.';
  };

  const getSeverity = () => {
    if (isInGracePeriod) {
      return 'error';
    }
    if (daysRemaining !== null && daysRemaining <= 7) {
      return 'error';
    }
    return 'warning';
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 64, // Below AppBar
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.drawer - 1,
      }}
    >
      <Alert
        severity={getSeverity()}
        icon={<WarningIcon fontSize="inherit" />}
        action={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button
              color="inherit"
              size="small"
              onClick={() => navigate('/settings/license')}
            >
              View License
            </Button>
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={dismissLicenseWarning}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
        }
        sx={{
          borderRadius: 0,
          '& .MuiAlert-message': {
            width: '100%',
          },
        }}
      >
        <AlertTitle>
          {isInGracePeriod ? 'License Expired - Grace Period Active' : 'License Warning'}
        </AlertTitle>
        {getMessage()}
      </Alert>
    </Box>
  );
};

export default LicenseWarningBanner;
